export const POS_PROVIDERS = Object.freeze({
  WEPOS: 'WEPOS',
  AGORA: 'Ágora',
  LAST_APP: 'Last.app',
});
